import { stumble } from '@ipfabric/frontend-shared-assets/utils/stumble/stumble';
import type { GraphPath } from '@ipfabric/utils';
import { recordFilterWithKeyType } from '@ipfabric/utils/fp/recordFilterWithKeyType';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { record } from 'fp-ts';
import { pipe } from 'fp-ts/lib/pipeable';
import { makeUpdateNodesVisibility } from '../helpers/updateNodesVisibility';
import { selectPathLookupApplied } from '../model/selectors/graphMetadata/selectPathLookupApplied';
import { performUndoableAction } from './history/performUndoableAction';

export interface UnhideNodeCommand {
  path: GraphPath;
}

export const unhideNodesInPath: GraphCommandFactory<UnhideNodeCommand> =
  (cmdContext, dispatch) => (command) => {
    if (selectPathLookupApplied(cmdContext.getState())) {
      stumble('Unhiding nodes is not allowed for Path-lookup');
      return;
    }

    const {
      graph: { hiddenNodes },
      peekingAtHiddenNodes,
    } = cmdContext.getState();

    const nodes = pipe(
      cmdContext.getState().graph.nodes,
      recordFilterWithKeyType((node) => node.parentPath === command.path),
    );

    dispatch(performUndoableAction, {
      undo: makeUpdateNodesVisibility(
        cmdContext.updateState,
        Array.from(hiddenNodes),
        false,
        peekingAtHiddenNodes,
      ),
      redo: makeUpdateNodesVisibility(
        cmdContext.updateState,
        record.keys(nodes),
        true,
        peekingAtHiddenNodes,
      ),
    });
  };
